import { render, staticRenderFns } from "./permitTree.vue?vue&type=template&id=43477a2f&scoped=true"
import script from "./permitTree.vue?vue&type=script&lang=js"
export * from "./permitTree.vue?vue&type=script&lang=js"
import style0 from "./permitTree.vue?vue&type=style&index=0&id=43477a2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43477a2f",
  null
  
)

export default component.exports